import "./index.css";
import "./App.css";

import React from "react";
import ReactDOM from "react-dom/client";
//  Redux imports
import { Provider } from "react-redux";

import App from "./App";
import store from "./redux/store";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            {" "}
            {/*  Wrap the App in Redux Provider */}
            <App />
        </Provider>
    </React.StrictMode>,
);

// Optional: performance analytics
reportWebVitals();
